// Added by Sejune Oh on 2020-02-28
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import React, { FC } from 'react';
import {
    FormControlLabel as MaterialFormControlLabel,
    FormControlLabelProps as MaterialFormControlLabelProps
} from '@material-ui/core'

export interface FormControlLabelProps extends MaterialFormControlLabelProps { }
export const FormControlLabel: FC<FormControlLabelProps> = ({ ...props }) => {
    return <MaterialFormControlLabel {...props} />
}
